import React, { createContext, useContext, useEffect, useState } from 'react'
import { branchesApi } from '../restaurant.api'

const BranchesContext = createContext({
  loading: true,
  branches: [],
  refresh: () => {},
})

export const useBranches = () => useContext(BranchesContext)

export const BranchesProvider = ({ children }) => {
  const [loading, setLoading] = useState(true)
  const [branches, setBranches] = useState([])

  const load = async () => {
    setLoading(true)
    const { response } = await branchesApi.list()
    if (response) setBranches(response.data || [])
    setLoading(false)
  }

  useEffect(() => {
    load()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <BranchesContext.Provider value={{ loading, branches, refresh: load }}>
      {children}
    </BranchesContext.Provider>
  )
}
